import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconDistance24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="distance">
            <path
                d="M2 11H6V13H2V22H0V2H2V11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M24 22H22V13H18V11H22V2H24V22Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14 13H10V11H14V13Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
